import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4ccecb52")

_pushScopeId("data-v-4ccecb52")
const _hoisted_1 = { class: "mt-4 mx-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", null, "Boostpack Unsubscribe", -1)
const _hoisted_4 = {
  key: 0,
  class: "mt-0 sm:justify-between px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createVNode("h1", null, "Boostpack wurde erfolgreich abgemeldet!", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_default_button = _resolveComponent("default-button")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.isValidHash)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _hoisted_3,
            (!_ctx.unsubscribeSuccessful)
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  _createVNode(_component_default_button, {
                    "button-text": _ctx.$t('modal.ConfirmDialog.unsubscribeBoostpack'),
                    "button-color": "bg-bp",
                    "button-width": "w-5/6 sm:w-auto",
                    "button-x-padding": "px-1 sm:px-12",
                    class: "mb-0",
                    style: {"margin-block":"initial","margin-bottom":"1rem"},
                    onClick: _ctx.unsubscribe
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("modal.ConfirmDialog.unsubscribeBoostpack")), 1)
                    ]),
                    _: 1
                  }, 8, ["button-text", "onClick"])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_5, [
                  _hoisted_6
                ]))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})